import "../sass/style.scss";
import * as header from "./header";
import headerHeight from "./headerHeight";
import scrollEffect from "./scrollEffect";
import slider from "./slider";
import smallResponsive from "./smallResponsive";
import postRss from "./post";
import newsRss from "./news";

postRss();
newsRss();
smallResponsive();

function switchByWidth() {
  if (window.matchMedia("(min-width: 1280px)").matches) {
    headerHeight();
  }
}

window.onload = switchByWidth;
window.onresize = switchByWidth;

const kvHeight = document.getElementById("head").offsetHeight + 100;
const head = document.getElementsByClassName("header -top");

window.addEventListener("resize", function () {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  if (scrollTop > kvHeight) {
    head[0].classList.add("is-active");
  } else {
    head[0].classList.remove("is-active");
  }
});

window.addEventListener("scroll", function () {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  if (scrollTop > kvHeight) {
    head[0].classList.add("is-active");
  } else {
    head[0].classList.remove("is-active");
  }
});

slider();
header.toggleMenu();
scrollEffect();

// ウィンドウの読み込みが完了したとき
document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;
  if (body && body.classList.contains("fade")) {
    body.classList.remove("fade");
  }
});
